import { adminRepositories } from "data/admin/repositories";
import { seedSitePages } from "data/seedSitePages";

export const sitePagesRepo = {
  list(params) {
    return adminRepositories.sitePages.list(params);
  },

  getById(id) {
    return adminRepositories.sitePages.getById(id);
  },

  create(item) {
    return adminRepositories.sitePages.create(item);
  },

  update(id, patch) {
    return adminRepositories.sitePages.update(id, patch);
  },

  remove(id) {
    return adminRepositories.sitePages.remove(id);
  },

  restore(id) {
    return adminRepositories.sitePages.restore(id);
  },

  /** Eksik marketing sayfalarını seed’den ekler; mevcut kayıtları bozmaz. */
  seedMissingDefaults() {
    const existing = new Set(this.list({ includeDeleted: true }).map((item) => item.id || item.slug));
    let created = 0;
    for (const item of seedSitePages) {
      const id = item.id || item.slug;
      if (!id || existing.has(id)) continue;
      this.create(item);
      created += 1;
    }
    return created;
  },
};
